
import { fetchApi } from './api';
import { loadAISettings } from '../settings/aiSettings';

export interface ChatMessage {
    role: 'user' | 'assistant';
    content: string;
    imageUrl?: string;
}

interface ChatRequest {
    messages: ChatMessage[];
    contextVerses?: { num: string; text: string; ref?: string }[];
    contextText?: string;
    contextMeta?: { title?: string; author?: string; bookId?: string; chapter?: number | string; pageLabel?: string; isPublicDomain?: boolean; corpusName?: string };
    personaText?: string;
    ref?: string;
    style?: 'concise' | 'normal' | 'detailed';
    personaAddon?: string;
    studyMode?: boolean;
    corpusName?: string;
    authorVoice?: boolean;
    explainPage?: boolean;
}

export async function sendAiChat(req: ChatRequest): Promise<{ ok: boolean; answer?: string; error?: string }> {
    // Check settings first
    const settings = loadAISettings();
    if (!settings.enableOnline) {
        return { ok: false, error: 'Enable online features in Settings to use chat.' };
    }

    try {
        const res = await fetchApi('/ai/chat', {
            method: 'POST',
            body: {
                provider: 'openai',
                messages: req.messages,
                contextVerses: req.contextVerses,
                contextText: req.contextText,
                contextMeta: req.contextMeta,
                personaText: settings.personaText || req.personaText,
                ref: req.ref,
                style: req.style || 'concise',
                studyMode: req.studyMode,
                corpusName: req.corpusName,
                authorVoice: req.authorVoice,
                explainPage: req.explainPage
            }
        });

        // Check for 404 (function missing/proxy not running)
        if (res.status === 404) {
            return { ok: false, error: 'Chat endpoint not found. Ensure Cloudflare Functions or local proxy is running.' };
        }

        const data = await res.json();
        if (!res.ok) {
            return { ok: false, error: data.error || 'Unknown server error' };
        }

        return data;
    } catch (err: any) {
        return { ok: false, error: err.message };
    }
}
